export const handleAddOption = (
	options: string[],
	onUpdateOptions?: (options: string[]) => void
) => {
	if (!onUpdateOptions) return;

	const newOptions = [...options, `Option ${options.length + 1}`];

	onUpdateOptions(newOptions);
};

export const handleRemoveOption = (
	index: number,
	options: string[],
	onUpdateOptions?: (options: string[]) => void
) => {
	if (!onUpdateOptions || options.length <= 2) return;

	const newOptions = [...options];
	newOptions.splice(index, 1);

	onUpdateOptions(newOptions);
};

export const handleOptionLabelChange = (
	index: number,
	newLabel: string,
	options: string[],
	onUpdateOptions?: (options: string[]) => void
) => {
	if (!onUpdateOptions) return;

	const newOptions = [...options];
	newOptions[index] = newLabel;

	onUpdateOptions(newOptions);
};

import type { FormField } from "../../../types/formTypes";

// A common interface for all field preview components
export interface BaseFieldPreviewProps {
	field: any;
	renderDescription: () => React.ReactNode;
	onUpdateOptions?: (options: string[]) => void;
	onUpdateField?: (updates: Partial<FormField>) => void;
}
